import { CheckCircle, ExclamationCircle, PaperPlane } from "flowbite-react-icons/solid";
import { useState } from "preact/hooks";
import PropTypes from "prop-types";
import toast from "react-hot-toast";
import Button from "@/components/buttons/button.jsx";
import NumberInput from "@/components/input/number.input.jsx";
import useTiltifyTestDonations from "@/hooks/useTestDonations";
import useTiltifyConfig from "@/hooks/useTiltifyConfig.js";

SendTestDonation.propTypes = {
  instructions: PropTypes.string.isRequired,
  sendButtonText: PropTypes.string,
  donationType: PropTypes.string,
};

export default function SendTestDonation({
  instructions,
  sendButtonText = "Send",
  donationType = "alert",
}) {
  const [testDonationAmount, setTestDonationAmount] = useState(null);
  const [canSendTestAlert, setCanSendTestAlert] = useState(!!testDonationAmount);

  const { sendTestDonationAsync } = useTiltifyTestDonations();

  const tiltifyConfig = useTiltifyConfig();

  function sendTestAlert() {
    setCanSendTestAlert(false);

    const donation = {
      id: crypto.randomUUID(),
      donor_name: "Anonymous",
      donor_comment: "This is a test donation",
      amount: { value: Number.parseFloat(testDonationAmount).toFixed(2), currency: "USD" },
      campaign_id: tiltifyConfig.tiltifyCampaignID,
      cause_id: "400f5687-6017-4d1a-a4d9-7c9166b984c2",
      completed_at: new Date().toISOString(),
      fundraising_event_id: null,
      poll_id: null,
      poll_option_id: null,
      reward_claims: null,
      reward_id: null,
      sustained: null,
      target_id: null,
      team_event_id: null,
    };

    sendTestDonationAsync(donation)
      .then(() => {
        toast(
          <>
            <CheckCircle />
            <span>Test {donationType} sent</span>
          </>,
          {
            position: "top-center",
            className: "alert-success text-white",
          },
        );
        setCanSendTestAlert(true);
      })
      .catch((err) => {
        // biome-ignore lint/suspicious/noConsole: log the error without surfacing it to the user
        console.error(err);
        toast(
          <>
            <ExclamationCircle />
            <span>Failed to send test {donationType}</span>
          </>,
          {
            position: "top-center",
            className: "alert-error text-white",
          },
        );
        setCanSendTestAlert(true);
      });
  }

  function testDonationAmountChanged(e) {
    setTestDonationAmount(e.target.valueAsNumber);
    setCanSendTestAlert(e.target.valueAsNumber > 0);
  }

  return (
    <article className="prose text-sm my-6">
      <div className="divider" />

      <div className="flex w-full items-center mb-10">
        <NumberInput
          className="flex-grow"
          inputClassName="input-lg"
          name="minAudio"
          value={testDonationAmount}
          placeholder="5.00"
          onChange={testDonationAmountChanged}
          isCurrency={true}
          maxLength={4}
          minValue={0}
          labelText="Test Amount"
          description={instructions}
        />

        <div className="tooltip" data-tip={sendButtonText}>
          <Button
            onClick={sendTestAlert}
            mode="button"
            className="ml-2 btn-lg"
            disabled={!canSendTestAlert}
          >
            <PaperPlane className="rotate-90" />
          </Button>
        </div>
      </div>
    </article>
  );
}
